import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async liberarBloqueiosPedido(axios, parametros) { 
    parametros.operacao = 'liberarBloqueiosPedido';

    let retorno = {};
    await axios.santriPOST('/rest/orcamento', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })
  
    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoLiberarBloqueiosPedido.js